module.exports = __webpack_public_path__ + "images/menud5b73906692d8d2e951f9a174a3152cd.svg";